import React from 'react'

const AboutUs = () => {
  return (
    <div id='website-responsive'>
    <div className='left-padding6rem1 right-padding6rem1 pt-md-5 py-4'>
        <div className=''>
            <text className='fs-ss-32-5 text-montserrat fw-700 text-ss-primary'>
                ABOUT US
                <hr className='hr-style my-1' style={{ width:'50px', marginTop:'0px', marginBottom:'4px'}}/>
            </text>
        </div>

        <div className='pt-1'>
            <text className='fs-ss-20 text-montserrat fw-600 text-ss-black' style={{ fontStyle:'italic'}}>
                Lab Testing Services in Chicago
            </text>
        </div>

        <div className='pt-3 pb-3'>
            <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
            Because of our consistent dedication to regulatory compliance, scientific standards, integrity, and impartiality, both established and growing companies rely on us. We have a strong and highly qualified team who can manage your testing quickly, precisely, and on schedule. We have a reputation for quality thanks to our sustained dedication to the industry, leadership, and creativity in research and development excellence.
            </text>
        </div>

        <div className='py-3'>
            <text className='fs-ss-16 text-montserrat fw-600' style={{ letterSpacing:'0.5px'}}>
            Our team tests your samples in a CAP-certify and CLIA-confirmed lab that satisfies the most noteworthy guidelines of constancy and idealness of experimental outcomes. As a result, we stand tall and are committed to providing innovative test results so you can live a safe and healthy life.       
            </text>
        </div>

    </div>
</div>
  )
}

export default AboutUs